import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { WordDocumentTemplate } from '@work4all/models/lib/Classes/WordDocumentTemplate.entity';
import { SortDirection } from '@work4all/models/lib/DataProvider';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { OrganisationArea } from '../organisation-area';

import { EntityTableV8, IEntityTableV8 } from './entity-table/EntityTableV8';
import { useEntityDataTableV8 } from './entity-table/use-entity-data-table-v8';
import schema from './schemata/wordDocumentTemplate-table-schema.json';

type IDocumentTemplateCustomColumns = Record<string, never>;

const defaultSort = [{ field: 'body', direction: SortDirection.ASCENDING }];

const FORCE_REQUEST_FIELDS: WordDocumentTemplate = {
  groupId: null,
};

export function WordDocumentTemplateTable(props: IEntityTableV8) {
  const { forceRequestFields, ...rest } = props;

  const { t } = useTranslation();

  const dataTable = useEntityDataTableV8<
    WordDocumentTemplate,
    IDocumentTemplateCustomColumns
  >({
    ...rest,
    schema: schema as never,
    defaultSort,
    forceRequestFields: useMemo(
      () => ({ ...forceRequestFields, ...FORCE_REQUEST_FIELDS }),
      [forceRequestFields]
    ),
  });

  return (
    <EntityTableV8
      {...props}
      {...dataTable}
      areas={{
        left: {
          title: t('COMMON.ORGANISATION'),
          content: (
            <OrganisationArea
              entity={Entities.wordDocumentTemplate}
              table={dataTable.table}
            />
          ),
          resizable: true,
          collapsible: true,
          custom: true,
        },
      }}
    />
  );
}
